export const redirect_url = 'https%3A%2F%2Fchat.minimaxi.com%2Fwxscan';
export const AppId = 'wx3572110fad830c98';
export const QRCodeStyleHref =
  'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4OyBoZWlnaHQ6MTgwcHg7IG1hcmdpbi10b3A6MDsgYm9yZGVyOiBub25lO30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA==';
export const QRCodeObj = {
  self_redirect: true,
  id: 'wxcode',
  appid: AppId,
  scope: 'snsapi_login',
  redirect_uri: redirect_url,
  state: 'hailuo',
  href: QRCodeStyleHref,
};

export const WECHAT_LOGIN = '微信扫码登录';

export const PRO_TARGET_ORIGIN_LIST = [
  'https://hailuoai.com',
  'https://chat.minimaxi.com',
  'https://hailuo-pre-v2.xaminim.com/',
];

export const PHONE_LENGTH = 11;
